import Svg from "../../../assets/images/ds-logo.svg?react";
import styles from "../Dropdown/dropdown.css.js";

/**
 * Renders the company logo as React SVG element.
 *
 * @return {JSX.Element} The Image element displaying the company's logo.
 */
export function Logo() {
  return <Svg alt="Digital Sparks" className={styles.logo} />;
}
